<div class="property-abstract">
  @let pa=propertyAbstract()!;
  <div class="pa-row flex-row">
    <div class="pa-image flex-row">
      <div [style.background-color]="pa.dashboardMarkerColor" class="status-marker"></div>
      @if (pa.imageReference) {
        <img [src]="pa.imageReference" class="property-image">
      }
      @else {
        <img src="assets/images/others/no_image.jpg" class="property-image">
      }
    </div>
    <div class="pa-sections flex-row w-100">
      <div class="pa-section pa-status flex-col justify-center text-sm">
        @if(isAuction){
          @if (pa.isLive || pa.auctionEnded) {
            <div class="flex-row">
              @if (pa.reserveMet) {
                <span class="green-color">RM</span>
              }
              @else {
                <span class="red-color">RNM</span>
              }
              <span class="mx-2">|</span>
              <a class="primary-color bidCount" (click)="onBidsClick(); $event.stopPropagation();">{{pa.displayBidCount}}</a>
            </div>
          }
          @if (pa.currentBid) {
            <div class="text-bold">{{pa.currentBid | currency:'USD':'symbol':'1.2-2'}}</div>
          }
          @else if (!pa.currentBid && pa.reservePrice) {
            <div class="text-bold">{{pa.reservePrice | currency:'USD':'symbol':'1.2-2'}} (Reserve)</div>
          }
          @if (pa.isLive && pa.auctionEnding) {
            <div>Ends: {{pa.auctionEnding | date:'short' }}</div>
          }
          @else if (pa.auctionEnded) {
            <div>Ended: {{pa.auctionEnding | date:'short' }}</div>
          }
        }
        @else if(isMakeOfferBuyNow){
          <div class="text-bold" [class]="pa.isLive?'green-color':''">Listing @if (!pa.isLive){<span>Not</span>} Live</div>
        }
        @else if(isRegularSale){
          <div class="text-bold" [class]="pa.isLive?'green-color':''">Listing @if (!pa.isLive){<span>Not</span>} Live</div>
        }
        @else if(isCallForOffer){
          <div class="text-bold" [class]="pa.isLive?'green-color':''">Listing @if (!pa.isLive){<span>Not</span>} Live</div>
        }
      </div>
      <mat-divider [vertical]="true" class="pa-divider pa-divider-first my-2"></mat-divider>
      <!-- forces address + client into a new row when the component is narrow (see scss) -->
      <div class="pa-break"></div>
      <div class="pa-section pa-address flex-col justify-center text-sm">
        <div>{{pa.address.streetAddress1}}</div>
        <div>{{pa.address.city}}, {{pa.address.state}} {{pa.address.zipCode}}</div>
        <div class="flex-row primary-color items-center space-between">
          @if(!readonly()) {<a class="primary-color propertyId" (click)="onPropertyIdClick(); $event.stopPropagation();">ID: {{pa.propertyId}}</a>}
        </div>
      </div>
      <mat-divider [vertical]="true" class="pa-divider my-2"></mat-divider>
      <!-- always rendered (content only if there is a client), so all listed components get the same section widths and aligned dividers -->
      <div class="pa-section pa-client flex-col justify-start text-sm">
        @if(pa.clientId){
          @let client = (getClient(pa.clientId) | async);
          <div class="flex-row space-between items-center">
            @if(client){
              @if(!isClient){
                <div class="primary-color text-bold">{{client.name}}</div>
              }
            }
            @else {<span></span>}
            @if(!portfolioContext() && pa.portfolioId){
              <div class="flex-row justify-end pr-3">Portfolio</div>
            }
          </div>
          @if(client){
            <div class="text-sm">{{(getSaleType(pa) | async)?.name}}</div>
            @if(!isClient){
              <div class="flex-col">
                @for(contact of client.contacts; track $index){
                  @if($index < 1){<div class="primary-color contact">{{contact.firstName}} {{contact.lastName}} ({{contact.email}})</div>}
                }
              </div>
            }
          }
        }
      </div>
    </div>
   
  </div>
</div>